module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAARCAAAAADiEzPsAAAAAXNSR0IArs4c6QAAAJdJREFUGNPN0M0KgkAUBWDf/xF0MS1mpjRbuxKJGoIkokVClkLYLyYxNKWzOm1HKWjZ3X6Lc8618OWsf4BXPLQdP667kPSik24OEdm0Yc5L5P5ojytfmJD2n5D0VlIFxXYG8AzIx0BYANuBAWtXQ7FjwWo0bmJmTDyJcxBccPdEu9WSzCqgEmTV3SGn1HaYeHxarvVPL3kDUtKFDh0yinoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/look.png
// module id = cohb
// module chunks = 2